export default __webpack_public_path__ + "static/media/arrow-right.be3e9f91.svg";